require('./mortgageRequestSimpleNoteResultView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { some, contains } = require('lodash');
const { connect } = require('react-redux');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @ actions
const getRequestInmuebles = require('actions/mortgageRequest/mortgageRequestInmuebles');
const stateActions = require('actions/mortgageRequest/mortgageRequestState');

// @ components
const MortgageRequestSimpleNoteList = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestResultSimpleNote/mortgageRequestSimpleNoteList');

// @ constants
const mortgageRequestPanelStates = require('constants/mortgageRequestPanelStates');

class MortgageRequestSimpleNoteResultView extends React.Component {
    constructor(props) {
        super(props);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    componentWillMount() {
        this.props.requestInmuebles();
    }

    componentWillReceiveProps(nextProps) {
        const nextList = nextProps.inmueblesState.get('list');

        if (nextProps.inmueblesState.get('hasBeenFetched')) {
            let hasDictamen;
            if (nextList.count() > 0) {
                hasDictamen = this.validateDictamen(nextList);
            }
            if (nextList.count === 0 || !hasDictamen) {
                this.props.history.push('/myprofile/mortgage/simple-note');
            }
        }
    }

    getBreadcrumb() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");

        return [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestSimpleNoteResult-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);
    }

    handleRedirect() {
        event.preventDefault();
        this.props.requestState('/myprofile/mortgage/panel', this.props.history)
    }

    validateDictamen(lista) {
        const listInmueble = lista.toJS();
        return some(listInmueble, item => item.resultadoDictamen === '1');
    }

    render() {
        const { inmueblesState, mortgageRequestState } = this.props;
        const mappingBreadcrumb = this.getBreadcrumb();
        const listInmueble = inmueblesState.get('list');
        const wasFetched = inmueblesState.get('hasBeenFetched');
        const hasDictamen = listInmueble.count() > 0 ? this.validateDictamen(listInmueble) : false;
        const currentState = mortgageRequestState.get('estado');
        const isApprovedDataSimpleNote = contains(mortgageRequestPanelStates.APPROVED_STATES_LIVING_PLACE, currentState);

        const showErrorEmpty = (
            <div>
                <LoadingSection />
            </div>
        );

        const InmuebleList = (
            <div className="mortgage-request-simple-note-result-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestSimpleNoteResult-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <ContentBox>
                                    <MortgageRequestSimpleNoteList inmueblesList={listInmueble} />
                                    <hr />
                                    <div className="row">
                                        <div className="col-md-2">
                                            <div className="pull-left">
                                                <OKLink
                                                    modifier="complementary"
                                                    to="/myprofile/mortgage/panel"
                                                >
                                                    {formatText('mortgageRequestCommons-returnText')}
                                                </OKLink>
                                            </div>
                                        </div>
                                        <div className="col-md-10">
                                            <OKButton id="mortgage-request-simple-note-view__accept-button" modifier="primary pull-right" onClick={this.handleRedirect} disabled={isApprovedDataSimpleNote}>
                                                {formatText('mortgageRequestCommons-acceptButtonText')}
                                            </OKButton>
                                        </div>
                                    </div>
                                </ContentBox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <div>
                {wasFetched && hasDictamen ? InmuebleList : showErrorEmpty}
            </div>
        );
    }
}

module.exports.constructor = MortgageRequestSimpleNoteResultView;

MortgageRequestSimpleNoteResultView.propTypes = {
    history: PropTypes.object.isRequired,
    mortgageRequestState: PropTypes.object,
    requestInmuebles: PropTypes.func,
    inmueblesState: PropTypes.object,
    immGlobalPosition: PropTypes.object.isRequired,
    requestState: PropTypes.func
};

module.exports.MortgageRequestSimpleNoteResultView = connect(
    state => ({
        mortgageRequestState: state.mortgageRequestState,
        inmueblesState: state.mortgageRequestInmuebles,
        immGlobalPosition: state.globalPosition,
    }),
    {
        requestInmuebles: getRequestInmuebles.requestInmuebles,
        requestState: stateActions.requestState
    }
)(withRouter(MortgageRequestSimpleNoteResultView));
